import { ComponentRef, Directive, EmbeddedViewRef, Input, OnChanges, OnDestroy, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { Subject } from 'rxjs';
import { NavbarSkeletonComponent } from '../components/navbar-skeleton/navbar-skeleton/navbar-skeleton.component';

@Directive({
    selector: '[featureLoadingNavbarSkeleton]',
    standalone: false
})
export class NavbarSkeletonDirective implements OnInit, OnDestroy, OnChanges {
  @Input('featureLoadingNavbarSkeleton') navbarItems = 7;
  @Input('featureLoadingNavbarSkeletonIsLoading') isLoading = true;

  private ngUnsubscribe = new Subject<void>();
  private view: EmbeddedViewRef<unknown>;
  private skeletonView?: ComponentRef<NavbarSkeletonComponent>;
  private initialLoadPassed = false;
  constructor(private tpl: TemplateRef<unknown>, private vcr: ViewContainerRef) {
    this.view = this.vcr.createEmbeddedView(this.tpl);
    for (let i = 0; i < this.view.rootNodes[0].children?.length; i++) {
      this.view.rootNodes[0].children[i].classList.add('hidden-content');
    }
  }

  ngOnInit(): void {
    this.skeletonView = this.vcr.createComponent(NavbarSkeletonComponent);
    this.skeletonView.instance.navbarItems = this.navbarItems;
    const skeletonViewRoot: HTMLElement | null = this.skeletonView.location.nativeElement;
    if (skeletonViewRoot) {
      skeletonViewRoot.style.display = this.isLoading ? 'block' : 'none';
    }
  }

  ngOnChanges(): void {
    const skeletonViewRoot: HTMLElement | null = this.skeletonView?.location.nativeElement;
    if (this.isLoading) {
      for (let i = 0; i < this.view.rootNodes[0].children?.length; i++) {
        this.view.rootNodes[0].children[i].classList.add('hidden-content');
      }
      if (skeletonViewRoot) {
        skeletonViewRoot.style.display = 'block';
      }
      this.initialLoadPassed = true;
    }
    if (!this.isLoading && this.initialLoadPassed) {
      if (skeletonViewRoot) {
        skeletonViewRoot.style.display = 'none';
      }
      for (let i = 0; i < this.view.rootNodes[0].children?.length; i++) {
        this.view.rootNodes[0].children[i].classList.remove('hidden-content');
      }
    }
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
